import React, { Component } from 'react';
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import * as moment from 'moment';
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import StringInput from "../../components/Input/StringInput/StringInput";
import Select from "../../components/Input/Select/Select";
import Button from "../../components/Button/Button";
import ImageUpload from "../../components/Input/ImageUpload/ImageUpload";
import DatePicker from "react-datepicker";
import Tab from "../../components/Tab/Tab";
import { getCountry } from "../../store/ducks/home/actions";
import { postBanner, getCategory } from "../../store/ducks/banners/actions";
import { withNamespaces } from "react-i18next";
import Lightbox from 'react-image-lightbox';
import ValidationError from "../../components/ValidationError/ValidationError";
import { formValidation } from "../../hoc/Shared/utility";

//Initialize the language array first
let langArr = [];
let categoryArry = [];
let dt = new Date();

// let formData = new FormData();
class BannersCreate extends Component {

    state = {
        desktop_image_preview: [],
        mobile_image_preview: [],
        // image_desktop_name: [],
        // image_mobile_name: [],
        image_link_desktop_image: [],
        redirect_url: [],
        desktop_image: [],
        mobile_image: [],
        start_time: dt.setHours(dt.getHours() + 2, 0),
        end_time: dt.setHours(dt.getHours() + 3, 0),
        category: [],
        sequence: '',
        currentStatus: 1,
        currentGroupName: [],
        loading: true,
    };

    componentDidMount() {
        formValidation('banner_form');


        const countryData = {};
        countryData.country_id = this.props.currentCountryId || this.state.currentCountryId;

        this.props.getCategory();
        this.props.getCountry(countryData);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // if(nextProps.post_banner_result !== this.props.post_banner_result){
        //     if(nextProps.post_banner_result.responseCode === 200){
        //         const { t } = this.props;
        //         Swal.fire({
        //             title: t("global.record-saved"),
        //             icon: nextProps.post_banner_result.msgType,
        //             confirmButtonText: t("global.ok"),
        //         }).then((result) => {
        //             if (result.isConfirmed) {
        //                 this.props.refreshHandler();
        //                 this.props.changePageHandler('listing');
        //             }
        //         })
        //     }else{
        //         return false;
        //     }

        // }

        if (nextProps.post_banner_result !== this.props.post_banner_result) {
            if (nextProps.post_banner_result.responseCode === 200) {
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.post_banner_result.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler('listing');
                    }
                })
            } else if (nextProps.post_banner_result.responseCode === 422) {
                this.setState({
                    loading: false,
                    touched: true,
                    error_message: nextProps.post_banner_result.message
                });
                Swal.close();
            } else {
                this.setState({ loading: false });
                const { t } = this.props;
                Swal.fire({
                    title: nextProps.post_banner_result.message[0],
                    icon: nextProps.post_banner_result.msgType,
                    confirmButtonText: t("global.ok"),
                })
            }
        }

        if (nextProps.country_data !== this.props.country_data) {
            let data = nextProps.country_data.data.language;

            this.setState({ loading: false });
            //Clear the languages array
            langArr = [];

            Object.keys(data).map((item, i) => {
                return langArr.push({
                    'langId': data[item].languageId,
                    'langCode': data[item].languageCode,
                    'langName': data[item].languageName
                });
            })
        }

        if (nextProps.category_data !== this.props.category_data) {
            if (nextProps.category_data.data.responseCode === 200) {
                const { t } = this.props;
                Swal.close();
                categoryArry = [];
                let data = nextProps.category_data.data.data;
                Object.keys(data).map((item, i) => {
                    return categoryArry.push({
                        'label': t('game-type.' + data[item].slug),
                        'value': data[item].slug,
                        'key': data[item].Id,
                    });
                })
            }
        }

        return true;
    }

    postBannerHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;

        Swal.fire({
            title: t("global.confirmation"),
            text: t("global.are-you-sure"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t("global.save"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {

                Swal.fire({
                    title: '',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    onOpen: () => {
                        Swal.showLoading()
                    }
                });

                let formData = new FormData();
                const prefix = 'promos/';
                const desktop_image = this.state.desktop_image;
                const mobile_image = this.state.mobile_image;
                // const image_desktop_name = this.state.image_desktop_name;
                // const image_mobile_name = this.state.image_mobile_name;
                // const image_link_desktop_image = this.state.image_link_desktop_image;
                // const image_link_mobile_image = this.state.image_link_mobile_image;
                // const currentCategory = this.state.category;

                desktop_image.forEach((val, idx) => {
                    formData.append("desktop_image[" + idx + "]", val);
                });

                mobile_image.forEach((val, idx) => {
                    formData.append("mobile_image[" + idx + "]", val);
                });

                // image_desktop_name.forEach((val, idx) => {
                //     formData.append("image_name_desktop_image["+idx+"]", val);
                // });

                // image_mobile_name.forEach((val, idx) => {
                //     formData.append("image_name_mobile_image["+idx+"]", val);
                // });

                // image_link_desktop_image.forEach((val, idx) => {
                //     formData.append("image_link_desktop_image["+idx+"]", prefix + val);
                // });

                // image_link_mobile_image.forEach((val, idx) => {
                //     formData.append("image_link_mobile_image["+idx+"]", val);
                // });


                formData.append("start_time", moment(this.state.start_time).format("yyyy-MM-DD HH:mm"));
                formData.append("end_time", moment(this.state.end_time).format("yyyy-MM-DD HH:mm"));
                formData.append("status", this.state.currentStatus);
                formData.append("category", this.state.category);
                formData.append("sequence", this.state.sequence);
                formData.append("country_id", this.props.currentCountryId);
                formData.append("image_link_desktop_image", prefix + this.state.image_link_desktop_image);
                formData.append("redirect_url", this.state.redirect_url);

                this.props.postBanner(formData);
            }
        })

    }

    getDesktopImageHandler = (event, langId) => {
        let reader = new FileReader();
        let file = event[0];

        const { desktop_image_preview, desktop_image } = this.state;

        reader.onloadend = () => {

            desktop_image_preview[langId] = reader.result;
            desktop_image[langId] = file;

            this.setState({
                desktop_image_preview,
                desktop_image
            });
        };


        if (file) {
            reader.readAsDataURL(file);
        } else {
            desktop_image_preview[langId] = "";
            this.setState({
                desktop_image_preview
            })
        }

    };

    getMobileImageHandler = (event, langId) => {
        let reader = new FileReader();
        let file = event[0];

        const { mobile_image_preview, mobile_image } = this.state;

        reader.onloadend = () => {
            mobile_image_preview[langId] = reader.result;
            mobile_image[langId] = file;

            this.setState({ mobile_image_preview, mobile_image });
        };

        if (file) {
            reader.readAsDataURL(file);
        } else {
            mobile_image_preview[langId] = "";
            this.setState({
                mobile_image_preview
            })
        }

    }

    // getDesktopImageNameHandler = (event, langId) => {
    //     const {image_desktop_name} = this.state;
    //     image_desktop_name[langId] = event.target.value;

    //     this.setState({
    //         image_desktop_name
    //     });
    // }

    // getMobileImageNameHandler = (event, langId) => {
    //     const {image_mobile_name} = this.state;
    //     image_mobile_name[langId] = event.target.value;

    //     this.setState({
    //         image_mobile_name
    //     });
    // }

    getDesktopImageLinkHandler = (event, langId) => {
        const { image_link_desktop_image } = this.state;
        image_link_desktop_image[langId] = event.target.value;

        this.setState({
            image_link_desktop_image
        });
    }

    // getMobileImageLinkHandler = (event, langId) => {
    //     const {image_link_mobile_image} = this.state;
    //     image_link_mobile_image[langId] = event.target.value;

    //     this.setState({
    //         image_link_mobile_image
    //     });
    // }

    getSequenceHandler = (event) => {
        this.setState({ sequence: event.target.value });
    }

    getCategoryHandler = (event) => {
        this.setState({ category: event.target.value });
    }

    getImageLinkHandler = (event) => {
        this.setState({ image_link_desktop_image: event.target.value });
    }

    getRedirectUrlHandler = (event) => {
        this.setState({ redirect_url: event.target.value });
    }

    handleStartTimeChange = (date) => {
        this.setState({
            start_time: date,
        });
    };

    handleEndTimeChange = (date) => {
        this.setState({
            end_time: date
        });
    };

    changeStatusHandler = (event) => {
        this.setState({ currentStatus: event.target.value });
    }

    render() {
        const { t } = this.props;

        let tabMessage = null;
        let tabTitleMessage = null;
        let tabContentMessage = [];

        let languages = langArr;

        let home = [
            {
                label: t("banner.select-category"),
                value: '',
                selected: true
            },
        ];

        let statusArry = [
            {
                label: t("global.active"),
                value: 1,
                selected: true
            },
            {
                label: t("global.inactive"),
                value: 0,
            },
        ];

        tabTitleMessage = languages.map((language) => language.langName);

        tabContentMessage = languages.map((item) => (
            <Auxiliary>
                {this.state.isOpen && (
                    <Lightbox
                        mainSrc={this.state.currentImage}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                    />
                )}
                <div>
                    <div className='row'>
                        <div className="col-12 col-md-6">
                            <div className="form-group" key={item.langId}>
                                <label htmlFor="desktop_image">{t("banner.desktop-image")}</label>
                                <ImageUpload
                                    id="desktop_image"
                                    name={`desktop_image[${item.langId}]`}
                                    onChange={(event) => this.getDesktopImageHandler(event, item.langId)}
                                />

                                {/* {this.state.desktop_image_preview[item.langId] &&
                                    <div className="imgPreview banner-preview-image">
                                        <div className="uploadPictureContainer">
                                            <img
                                                alt=""
                                                className="banner"
                                                src={this.state.desktop_image_preview[item.langId]}
                                                onClick={() => this.setState({ isOpen: true, currentImage: this.state.desktop_image_preview[item.langId] })}
                                                style={{ "cursor": "pointer" }}
                                            />
                                        </div>
                                    </div>
                                } */}

                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="form-group" key={item.langId}>
                                <label htmlFor="mobile_image">{t("banner.mobile-image")}</label>
                                <ImageUpload
                                    id="mobile_image"
                                    name={`mobile_image[${item.langId}]`}
                                    onChange={(event) => this.getMobileImageHandler(event, item.langId)}
                                />

                                {/* {this.state.mobile_image_preview[item.langId] &&

                                    <div className="imgPreview banner-preview-image">
                                        <div className="uploadPictureContainer">
                                            <img
                                                alt=""
                                                className="banner"
                                                src={this.state.mobile_image_preview[item.langId]}
                                            />
                                        </div>
                                    </div>
                                } */}
                            </div>
                        </div>
                    </div>

                </div>

                {/* <div className="col-md-12">
                    <div className="form-group">
                        <label>{t("banner.desktop-image-name")}</label>
                        <StringInput
                            onChange={(event) => this.getDesktopImageNameHandler(event, item.langId)}
                            id="image_desktop_name"
                            name={`image_desktop_name[${item.langId}]`}
                            value={this.state.image_desktop_name[item.langId]}
                        />
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{t("banner.desktop-image-name")}</label>
                            <StringInput
                                onChange={(event) => this.getDesktopImageNameHandler(event, item.langId)}
                                id="image_desktop_name"
                                name={`image_desktop_name[${item.langId}]`}
                                value={this.state.image_desktop_name[item.langId]}
                            />
                        </div>
                    </div>
                </div> */}

                {/* <div className="col-md-6">
                        <div className="form-group">
                            <label>{t("banner.mobile-image-name")}</label>
                            <StringInput
                                onChange={(event) => {
                                    this.getMobileImageNameHandler(event, item.langId)
                                }}
                                id="image_mobile_name"
                                name={`image_mobile_name[${item.langId}]`}
                                value={this.state.image_mobile_name[item.langId]}
                            />
                        </div>
                    </div> */}

                {/* <div className="col-md-12">
                    <div className="form-group">
                        <label>{t("banner.desktop-image-link")}</label>
                        <StringInput
                            onChange={(event) => {
                                this.getDesktopImageLinkHandler(event, item.langId)
                            }}
                            id="image_link_desktop_image"
                            name={`image_link_desktop_image[${item.langId}]`}
                            value={this.state.image_link_desktop_image[item.langId]}
                        />
                    </div>
                </div> */}

            </Auxiliary>
        ));

        tabMessage = <Tab tabNav={tabTitleMessage} tabPanel={tabContentMessage} className="border" />;

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler('listing')}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("banner.banner")}</h4>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("banner.add-banner")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                {this.state.loading === true ? <Skeleton count={4} /> :
                                    <form method="post" id="banner_form" className="form-horizontal"
                                        onSubmit={this.postBannerHandler} noValidate>
                                        <ValidationError formName="banner_form" touched={this.state.touched} message={this.state.error_message} />

                                        <div className="row">
                                            <div className="col-md-12">

                                                <div className="row">
                                                    <div className="col-md-12">{tabMessage}</div>
                                                </div>
                                            </div>


                                        </div>

                                        <div className="row">
                                            <div className="col-md-4">
                                                <label>{t("banner.desktop-image-link")}</label>
                                                <StringInput
                                                    onChange={this.getImageLinkHandler}
                                                    name="image_link_desktop_image"
                                                    id="image_link_desktop_image"
                                                    value={this.state.image_link_desktop_image}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label>{t("banner.redirect-url")}</label>
                                                <StringInput
                                                    onChange={this.getRedirectUrlHandler}
                                                    name="redirect_url"
                                                    id="redirect_url"
                                                    value={this.state.redirect_url}
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t("banner.start-time")}</label>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend w-100">
                                                            <span className="input-group-text">
                                                                <FontAwesomeIcon icon={faCalendarCheck} />
                                                            </span>
                                                            <DatePicker
                                                                name="start_time"
                                                                className="form-control"
                                                                selected={this.state.start_time}
                                                                onChange={this.handleStartTimeChange}
                                                                minDate={new Date()}
                                                                showTimeSelect
                                                                dateFormat="yyyy-MM-dd HH:mm"
                                                                timeFormat="HH:mm"
                                                                timeIntervals={15}
                                                                timeCaption="time"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t("banner.end-time")}</label>
                                                    <div className="input-group">
                                                        <div className="input-group-prepend w-100">
                                                            <span className="input-group-text">
                                                                <FontAwesomeIcon icon={faCalendarCheck} />
                                                            </span>
                                                            <DatePicker
                                                                name="end_time"
                                                                className="form-control"
                                                                selected={this.state.end_time}
                                                                onChange={this.handleEndTimeChange}
                                                                minDate={new Date()}
                                                                showTimeSelect
                                                                dateFormat="yyyy-MM-dd HH:mm"
                                                                timeFormat="HH:mm"
                                                                timeIntervals={15}
                                                                timeCaption="time"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label >{t('banner.category')}</label>
                                                    <Select
                                                        options={home.concat(categoryArry)}
                                                        name="category"
                                                        className="form-control"
                                                        onChange={this.getCategoryHandler}
                                                        value={this.state.category}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t("banner.sequence")}</label>
                                                    <NumberInput
                                                        onChange={(event) => this.getSequenceHandler(event)}
                                                        id="sequence"
                                                        name="sequence"
                                                        value={this.state.sequence}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>{t("banner.status")}</label>
                                                    <Select
                                                        id="status"
                                                        name="status"
                                                        className="form-control"
                                                        options={statusArry}
                                                        onChange={this.changeStatusHandler}
                                                    />
                                                </div>
                                            </div>



                                            <div className="col-12 form-group mb-0 justify-content-end">
                                                <div>
                                                    <Button
                                                        id="submit"
                                                        classValue="btn btn-blue"
                                                        typeButton="submit"
                                                        buttonName={t('global.save')}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        )
    }
}

const mapStateToProps = state => {
    const { home, banner, currentUser } = state;
    //Getting the state from the reducers
    return {
        country_data: home.country_data,
        category_data: banner.category_data,
        post_banner_result: banner.post_banner_result,
        currentCountryId: currentUser.data.country_id

    }
};

const mapDispatchToProps = {

    getCategory,
    getCountry,
    postBanner
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(BannersCreate));
